import { Competitor } from '../route-types';

export const COMPETITOR_NAME: Record<Competitor, string> = {
    [Competitor.Omegle]: 'Omegle',
    [Competitor.Monkey]: 'Monkey',
    [Competitor.Flingster]: 'Flingster',
    [Competitor.OmeTV]: 'OmeTV',
    [Competitor.Chatrandom]: 'Chatrandom',
    [Competitor.Coomeet]: 'Coomeet',
    [Competitor.Bazoocam]: 'Bazoocam',
    [Competitor.Dirtyroulette]: 'Dirtyroulette',
    [Competitor.Joingy]: 'Joingy',
}
